import PropTypes from 'prop-types';

export const ALLOCATION_UNIT_PROP_TYPE = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  unitCount: PropTypes.number
});

export const RULE_PROP_TYPE = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  subtype: PropTypes.string
});

export const COST_OBJ_PROP_TYPE = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  entityCode: PropTypes.string,
  locationDtoList: PropTypes.arrayOf(PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    city: PropTypes.string,
    costObjectId: PropTypes.number,
    country: PropTypes.string,
    id: PropTypes.number,
    locationType: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string
  }))
});

export const TARGET_FIELDS_PROP_TYPE = PropTypes.arrayOf(PropTypes.shape({
  name: PropTypes.string,
  label: PropTypes.string
}));

export const ARRAY_OF_NAME_LABEL_PROP_TYPE = PropTypes.arrayOf(PropTypes.shape({
  name: PropTypes.string,
  label: PropTypes.string
}));

export const LIST_OF_PROFILES = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  map: PropTypes.shape({
    transformedFileType: PropTypes.string
  })
}));



// WEBPACK FOOTER //
// ./src/shared/constants/PropTypes.js